import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5dbd434f&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=5dbd434f&prod&lang=less&"
import style1 from "./App.vue?vue&type=style&index=1&id=5dbd434f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd434f",
  null
  
)

export default component.exports